import { create } from "zustand";

export type LeaderboardOrdinationStore = {
  page: number;
  name: string;
  pageSize: number;
  currentOrder: "asc" | "desc";
  fieldOrder: string;

  setPage: (page: number) => void;
  setName: (name: string) => void;
  setCurrentOrder: (order: "asc" | "desc") => void;
  setFieldOrder: (field: string) => void;
  resetOrdination: () => void;
};

const useLeaderboardOrdinationStore = create<LeaderboardOrdinationStore>(
  (set: any) => ({
    page: 0,
    name: "",
    pageSize: 25,
    currentOrder: "desc",
    fieldOrder: "Overall",

    setPage: (page: number) => set(() => ({ page })),
    setName: (name: string) => set(() => ({ name })),
    setCurrentOrder: (currentOrder: "asc" | "desc") =>
      set(() => ({ currentOrder })),

    // Trocar de aba ou medalha reseta para desc
    setFieldOrder: (fieldOrder: string) =>
      set(() => ({ fieldOrder, currentOrder: "desc" })),

    resetOrdination: () => {
      set(() => ({
        page: 0,
        name: "",
        pageSize: 25,
        currentOrder: "desc",
        fieldOrder: "Overall",
      }));
    },
  }),
);

export default useLeaderboardOrdinationStore;
